module.exports = __webpack_public_path__ + "static/img/about_authority_03_zh.a1acdc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_authority_03_zh.png
// module id = UPVx
// module chunks = 34